import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "icon-key-container" }
const _hoisted_2 = { class: "icon-key-label" }


import ArtilleryLeftIcon from '../icons/ArtilleryLeft.vue';
import ArtilleryRightIcon from '../icons/ArtilleryRight.vue';
import BombIcon from '../icons/Bomb.vue';
import GunLeftIcon from '../icons/GunLeft.vue';
import GunRightIcon from '../icons/GunRight.vue';
import TankLeftIcon from '../icons/TankLeft.vue';
import TankRightIcon from '../icons/TankRight.vue';

import '@/assets/fonts/customIcon.css';


export default /*@__PURE__*/_defineComponent({
  __name: 'iconKey',
  props: {
    customIcon: { type: Boolean },
    icon: {},
    name: {},
    color: {}
  },
  setup(__props: any) {



function getCustomIconComponent(icon: string) {
  switch (icon) {
    case 'artillery-left': return ArtilleryLeftIcon;
    case 'artillery-right': return ArtilleryRightIcon;
    case 'bomb': return BombIcon;
    case 'gun-left': return GunLeftIcon;
    case 'gun-right': return GunRightIcon;
    case 'tank-left': return TankLeftIcon;
    case 'tank-right': return TankRightIcon;
    default: return null;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.customIcon && _ctx.icon && _ctx.color)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(getCustomIconComponent(_ctx.icon)), {
          key: 0,
          width: 20,
          height: 20,
          color: _ctx.color
        }, null, 8, ["color"]))
      : (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: _normalizeClass(['fas', _ctx.icon, 'icon']),
          style: _normalizeStyle({ color: _ctx.color || '#2c3e50' })
        }, null, 6)),
    _createElementVNode("div", _hoisted_2, "- " + _toDisplayString(_ctx.name), 1)
  ]))
}
}

})